import { gql } from "@apollo/client";

export const GET_COMMODITY_PUBLIC = gql`
  query publicCommodity($id: String!) {
    publicCommodity(id: $id) {
      id
      name
      createdAt
      createdBy
      measurementUnit
      categories
      imageURL
      status
      user {
        name
      }
      retailPrices {
        id
        price
        latest
        createdAt
      }
      wholeSalePrices {
        id
        price
        latest
        createdAt
      }
    }
  }
`;

export const GET_COMMODITIES_PUBLIC = gql`
  query getPublicCommodities($args: SearchItemsArgs!) {
    publicCommodities(args: $args) {
      items {
        id
        name
        createdAt
        imageURL
        measurementUnit
        categories
        status
        retail
        wholeSale
        user {
          name
          establishment {
            name
          }
        }
        retailPrices {
          id
          price
          latest
          createdAt
        }
        wholeSalePrices {
          id
          price
          latest
          createdAt
        }
      }
      meta {
        page
        count
        to
        total
        lastPage
      }
    }
  }
`;

export const GET_RETAIL_HISTORY_PUBLIC = gql`
  query commodity($id: String!) {
    publicCommodity(id: $id) {
      retailPrices {
        id
        price
        latest
        createdAt
      }
    }
  }
`;

export const GET_WHOLE_SALE_HISTORY_PUBLIC = gql`
  query commodity($id: String!) {
    publicCommodity(id: $id) {
      wholeSalePrices {
        id
        price
        latest
        createdAt
      }
    }
  }
`;

export const GET_USERS_PUBLIC = gql`
  query publicUsers($args: SearchUsersArgs!) {
    publicUsers(args: $args) {
      items {
        id
        name
      }
    }
  }
`;

export const GET_EXTERNAL_COMMODITIES_PUBLIC = gql`
  query publicExternalCommodities($args: SearchExternalItemsArgs!) {
    publicExternalCommodities(args: $args) {
      items {
        id
        name
        price
        source
      }
      meta {
        page
        count
        to
        total
        lastPage
      }
    }
  }
`;

// export const GET_RETAIL_HISTORY_PUBLIC = gql`
//   query commodity($id: String!) {
//     publicCommodity(id: $id) {
//       retailPrices {
//         id
//         price
//         latest
//         createdAt
//       }
//     }
//   }
// `;
